/*
 * Simple Bundles BYOB → Rebuy Smart Cart
 * Prevents BYOB from redirecting customers to /cart.
 */

if (!window.__lanesByobRebuyBridge) {
  window.__lanesByobRebuyBridge = true;

  document.addEventListener(
    'simple-bundles-byob:add-to-cart',
    async function (event) {
      if (!event.detail || !Array.isArray(event.detail.items)) return;

      /*
       * Prevent Simple Bundles' normal fallback behavior,
       * which redirects unsupported cart drawers to /cart.
       */
      event.preventDefault();

      const root =
        window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      const ajaxItems = event.detail.items.map(function (item) {
        const properties = {};

        if (Array.isArray(item.attributes)) {
          item.attributes.forEach(function (attribute) {
            properties[attribute.key] = attribute.value;
          });
        }

        const cartItem = {
          id: parseInt(
            item.merchandiseId.replace(
              'gid://shopify/ProductVariant/',
              ''
            ),
            10
          ),
          quantity: item.quantity || 1,
          properties: properties
        };

        if (item.sellingPlanId) {
          cartItem.selling_plan = parseInt(item.sellingPlanId, 10);
        }

        return cartItem;
      });

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: ajaxItems
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw data;
        }

        document.dispatchEvent(
          new CustomEvent(
            'simple-bundles-byob:add-to-cart:complete',
            {
              bubbles: true,
              detail: {
                cart: data,
                items: event.detail.items
              }
            }
          )
        );

        openByobRebuyCart();
      } catch (error) {
        console.error('Unable to add BYOB bundle:', error);

        document.dispatchEvent(
          new CustomEvent(
            'simple-bundles-byob:add-to-cart:error',
            {
              bubbles: true,
              detail: {
                errors: [error],
                items: event.detail.items
              }
            }
          )
        );
      }
    },
    true
  );

  function openByobRebuyCart() {
    function refreshAndOpen() {
      if (
        !window.Rebuy ||
        !Rebuy.Cart ||
        !Rebuy.SmartCart
      ) {
        return false;
      }

      Rebuy.Cart.fetchShopifyCart(function () {
        Rebuy.SmartCart.show();
      });

      return true;
    }

    if (!refreshAndOpen()) {
      document.addEventListener(
        'rebuy:smartcart.ready',
        refreshAndOpen,
        { once: true }
      );
    }
  }
}